// extracted by mini-css-extract-plugin
export default {"main":"Layout_main__jwJ69","mainAuth":"Layout_mainAuth__XF8M9"};